import { render, staticRenderFns } from "./Low.vue?vue&type=template&id=46f078c6"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46f078c6')) {
      api.createRecord('46f078c6', component.options)
    } else {
      api.reload('46f078c6', component.options)
    }
    module.hot.accept("./Low.vue?vue&type=template&id=46f078c6", function () {
      api.rerender('46f078c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/PriorityIcons/Low.vue"
export default component.exports